<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-05 09:54:58
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <mrc_ess_multiText :label="$t('label_cost_center_name') + '*'"
                               :isNational="judegNational('cost_center_name')"
                               :error-messages="
                $errors(
                  'list',
                  'cost_center_name',
                  requiredRule.concat(nocharacter)
                )
              "
                               v-model="list.cost_center_name"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="6">
            <mrc_ess_multiText :label="$t('label_short_code_of_module') + '*'"
                               :isNational="judegNational('cost_center_code')"
                               :error-messages="
                $errors(
                  'list',
                  'cost_center_code',
                  requiredRule.concat(nocharacter)
                )
              "
                               v-model="list.cost_center_code"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <!-- :error-messages="$errors('list','cost_center_description',requiredRule)" -->
            <mrc_ess_multiText :label="$t('label_note')"
                               noRequired
                               :error-messages="
                $errors('list', 'cost_center_description', nocharacter)
              "
                               :isNational="judegNational('cost_center_description')"
                               v-model="list.cost_center_description"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <v-row class="d-flex">
              <v-col>
                <mrc_ess_datePicker :label="$t('label_Start_date') + '*'"
                                    :disabled="disabled"
                                    :errMsg="
                    $errors(
                      'list',
                      'effective_start_date',
                      requiredRule.concat([
                        {
                          rule: 'beforeDate',
                          msg: $t('verify_cannot_exceed_the_expiration_date'),
                        },
                      ])
                    )
                  "
                                    v-model="list.effective_start_date"></mrc_ess_datePicker>
              </v-col>
              <div class="d-flex align-center">
                <span style="font-size: 22px;color: #383838;">></span>
              </div>
              <v-col>
                <mrc_ess_datePicker :label="$t('label_End_date')"
                                    :disabled="disabled"
                                    :errMsg="
                    $errors(
                      'list',
                      'effective_end_date',
                      [].concat([
                        {
                          rule: 'afterDate',
                          msg: $t('verify_no_later_than_the_start_time'),
                        },
                      ])
                    )
                  "
                                    v-model="list.effective_end_date"></mrc_ess_datePicker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  costCenterList,
  addCostCenter,
  delCostCenter,
  updateCostCenter,
  detailCostCenter,
} from "@/service/api/costCenter.js"
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      list: {},
      btnIsLoading: false,
    }
  },
  computed: {},
  created () { },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_cost_center'
          this.$store.commit('set_page_title', 'label_edit_cost_center')
        }
        else {
          this.$route.meta.title = 'label_view_cost_center'
          this.$store.commit('set_page_title', 'label_view_cost_center')
        }
      }, immediate: true
    }
  },
  async mounted () {
    this.national("mrbase_sys_cost_center")
    if (this.$store.state.uuid) {
      await this.getDetail()
    } else {
    }
  },
  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await detailCostCenter({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
      } else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      this.btnIsLoading = true
      if (this.$store.state.uuid) {
        const res = await updateCostCenter(this.$deletefield(null, this.list))
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
          this.getDetail()
          this.$emit("changereadonly")
        }
      } else {
        const res = await addCostCenter({
          org_level_uuid: this.$store.state.currentCompany,
          ...this.list,
        })
        if (res.code == 200) {
          this.$Message({ text: this.$t("message_added_successfully") })
          this.$router.push({ name: "cost-center" })
        }
      }
      this.btnIsLoading = false
    },
    async cancel () {
      if (this.$store.state.uuid) {
        this.getDetail()
        this.$emit("changereadonly")
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "cost-center",
            })
          })
          .catch((err) => { })
      }
    },
  },
  validations: {
    list: {
      cost_center_name: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      cost_center_code: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      cost_center_description: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      effective_start_date: {
        required,
        beforeDate (value) {
          if (!this.list.effective_end_date) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.list.effective_end_date).valueOf()
          return prevData < nextData
        },
      },
      effective_end_date: {
        afterDate (value) {
          if (!value) return true
          if (!this.list.effective_start_date) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.list.effective_start_date).valueOf()
          return prevData < nextData
        },
      },
    },
  },
}
</script>

<style scoped></style>
